import useHasPermission from 'app/hooks/useHasPermission'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    LocationsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/Location.requests'

import useHasLocationPermissionType from '../utils/useHasLocationPermissionType'
import {
    ROLES_PROSPECT_ALLOWED,
} from './Locations.types'
import LocationOverview from './LocationOverview'
import LocationUpdate from './LocationUpdate'
import LocationCreate from './LocationCreate'
import LocationAreas from './LocationAreas'
import SkyMindSyncContainer from './SkyMindSync'
import LocationChangeSummary from './LocationChangeSummary'
import tableConfig from './Locations.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const Locations = () => {
    const isAllowedToUpdateSkyMindCompany = useHasPermission(['company_skymind_update'])
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: LocationOverview,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.DataUpdate,
                label: 'Data Update',
                Component: LocationUpdate,
            },
            permission: true,
        },
        {
            tab: {
                url: LocationsTabs.Areas,
                label: 'Areas',
                Component: LocationAreas,
            },
            permission: true,
        },
        {
            tab: {
                url: LocationsTabs.SkyMind,
                label: 'SkyMind',
                Component: SkyMindSyncContainer,
            },
            permission: isAllowedToUpdateSkyMindCompany,
        },
        {
            tab: {
                url: CommonRoutes.ChangeHistory,
                label: 'Change History',
                Component: LocationChangeSummary,
            },
            permission: true,
        },
    ])
    const hasCreatePermissionsByMainCategory = useHasLocationPermissionType([], 'create')
    const hasCreatePermissionForProspectLocation = useHasPermission(ROLES_PROSPECT_ALLOWED)
    const hasCreatePermissions = hasCreatePermissionsByMainCategory
        || hasCreatePermissionForProspectLocation

    return (
        <SkyNetDomain
            actionComponents={{
                Create: hasCreatePermissions
                    ? LocationCreate
                    : undefined,
            }}
            name="Location"
            sidebarTabs={tabs}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName={requests.domainName}
                filter={requests.filter}
                tableControls={tableControls}
                tableConfig={tableConfig}
                customUrl={requests.all().url}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Locations
